(function () {
  const STORAGE_KEY = 'yingmart_custom_wishlist_v1';

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(items) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    updateWishlistButtons();
    updateWishlistCount();
    renderWishlistPage();
  }

  function isInWishlist(handle) {
    return getWishlist().some(item => item.handle === handle);
  }

  function addToWishlist(item) {
    const items = getWishlist();
    if (!items.some(x => x.handle === item.handle)) {
      items.push(item);
      saveWishlist(items);
    }
  }

  function removeFromWishlist(handle) {
    const items = getWishlist().filter(item => item.handle !== handle);
    saveWishlist(items);
  }

  function toggleWishlist(item) {
    if (isInWishlist(item.handle)) {
      removeFromWishlist(item.handle);
    } else {
      addToWishlist(item);
    }
  }

  function updateWishlistButtons() {
    document.querySelectorAll('[data-wishlist-button]').forEach(button => {
      const handle = button.dataset.handle;
      const text = button.querySelector('[data-wishlist-text]');
      const active = isInWishlist(handle);

      button.classList.toggle('is-active', active);

      if (text) {
        text.textContent = active ? 'Added to Wishlist' : 'Add to Wishlist';
      }
    });
  }

  function updateWishlistCount() {
    const count = getWishlist().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(el => {
      el.textContent = count;
      el.style.display = count > 0 ? 'inline-block' : 'none';
    });
  }

  function renderWishlistPage() {
    const containers = document.querySelectorAll('.custom-wishlist-page');
    if (!containers.length) return;

    const items = getWishlist();

    containers.forEach(container => {
      const emptyText = container.dataset.emptyText || 'Your wishlist is empty.';

      if (!items.length) {
        container.innerHTML = `<p class="custom-wishlist-empty">${emptyText}</p>`;
        return;
      }

      const html = `
        <div class="custom-wishlist-grid">
          ${items.map(item => `
            <div class="custom-wishlist-card">
              <a href="${item.url}">
                <img src="${item.image}" alt="${item.title}">
                <div class="custom-wishlist-title">${item.title}</div>
                <div class="custom-wishlist-price">${item.price}</div>
              </a>
              <button class="custom-wishlist-remove" data-remove-wishlist="${item.handle}">
                Remove
              </button>
            </div>
          `).join('')}
        </div>
      `;

      container.innerHTML = html;
    });

    document.querySelectorAll('[data-remove-wishlist]').forEach(btn => {
      btn.addEventListener('click', function () {
        removeFromWishlist(this.dataset.removeWishlist);
      });
    });
  }

  function initWishlistButtons() {
    document.querySelectorAll('[data-wishlist-button]').forEach(button => {
      if (button.dataset.initialized === 'true') return;
      button.dataset.initialized = 'true';

      button.addEventListener('click', function () {
        const item = {
          handle: this.dataset.handle,
          url: this.dataset.url,
          title: this.dataset.title,
          price: this.dataset.price,
          image: this.dataset.image
        };
        toggleWishlist(item);
      });
    });
  }

  function init() {
    initWishlistButtons();
    updateWishlistButtons();
    updateWishlistCount();
    renderWishlistPage();
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:reorder', init);
})();